import { render, staticRenderFns } from "./pc-leg-tc-categories-section.vue?vue&type=template&id=91eb8724&"
import script from "./pc-leg-tc-categories-section.vue?vue&type=script&lang=js&"
export * from "./pc-leg-tc-categories-section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports